import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from './icons';
export function RiskReversal() {
  return <section id="garantia" className="py-12 bg-brand-bg-dark relative overflow-hidden" data-id="element-240">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #D4860A 0, #D4860A 1px, transparent 0, transparent 50%)',
      backgroundSize: '20px 20px'
    }} data-id="element-241"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-243">
          <div className="bg-gradient-to-br from-brand-gold-dark/20 to-brand-bg-dark border-2 border-brand-gold rounded-2xl p-8 sm:p-12 md:p-16 shadow-[0_0_50px_rgba(200,169,81,0.15)] text-center" data-id="element-244">
            <div className="flex justify-center mb-8" data-id="element-245">
              <div className="bg-brand-gold/10 p-4 rounded-full border border-brand-gold/30" data-id="element-246">
                <ShieldIcon className="w-16 h-16 text-brand-gold" data-id="element-247" />
              </div>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white mb-10 uppercase tracking-widest" data-id="element-248">
              Nuestra Promesa Es Simple
            </h2>

            <div className="space-y-8" data-id="element-249">
              <p className="text-2xl sm:text-3xl font-medium text-gray-200 leading-relaxed max-w-3xl mx-auto" data-id="element-250">
                Si no quedas satisfecho con el trabajo antes del pago final —{' '}
                <strong className="text-brand-gold font-heading" data-id="element-251">
                  lo corregimos.
                </strong>
              </p>

              <p className="text-xl sm:text-2xl text-brand-red font-bold uppercase tracking-wider" data-id="element-252">
                Sin argumentos. Sin excusas.
              </p>

              <div className="w-24 h-1 bg-brand-gold mx-auto my-8 rounded-full" data-id="element-253"></div>

              <p className="text-xl text-gray-400 italic" data-id="element-254">
                Tu tranquilidad no es un extra — es parte del servicio.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}